module.exports = __webpack_public_path__ + "assets/img/cbb529782ead20d1504df06a82bd24a3.svg";